import { getErrorMessage } from '@/utils/errors';
import type { AttachableGroupKey } from './attachFilesApi';

// Centralised per react-gotchas.md ("Hardcoded user-facing copy"): these carry
// apostrophes, so they live here rather than inline at the call site.

export const ATTACH_FILES_LOAD_ERROR =
  'Unable to load files. Please try again.';

// The approval email carries these as real attachments, so the provider's size
// limit applies before send. Same 15 MB ceiling the offer template already
// enforces (offer-template/AddMoreFilesButton.tsx MAX_TOTAL_SIZE_MB), so an
// offer has one limit rather than two.
export const ATTACHMENT_SIZE_LIMIT_MB = 15;
export const attachmentSizeWarning = (limitMb: number): string =>
  `Total file size exceeds ${limitMb} MB. The approval email may not be delivered.`;

// The Figma frame doesn't cover an empty group, so this copy is ours.
export const GROUP_PLACEHOLDER_COPY: Record<AttachableGroupKey, string> = {
  candidate_details: 'No candidate files available',
  other_files: 'No other files available',
};

// Shown on the scorecards row while its PDF renders.
export const SCORECARD_GENERATING_ROW_LABEL = 'Generating…';

/**
 * Display copy for a rejected persistApprovalAttachments call.
 *
 * Resolved through the shared error modules (src/utils/errors) so these codes
 * read the same here as anywhere else in the app, and so cross-cutting consent
 * codes keep their approved wording. An unrecognised code falls back to the
 * default message rather than surfacing the raw `err_*` string.
 */
export const approvalAttachmentErrorCopy = (error: unknown): string =>
  getErrorMessage(
    (error as { response?: { data?: unknown } })?.response?.data,
    'offers'
  );

// Shown on the placeholder chip while an upload or a selection save is in
// flight — the file has no name on the server yet.
export const ATTACHMENT_UPLOADING_LABEL = 'Uploading…';
